module.exports = __webpack_public_path__ + "static/media/paymentFail.e39fda83.svg";